import React, { useContext, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Context } from "../../../index";
import { toast } from "react-toastify";
import { check, updateUserDataFront } from "../../../http/userAPI";

const ChangeAmzName = ({ show, onClose, assign, reviewData }) => {
    const { user } = useContext(Context);
    const [loading, setLoading] = useState(false);

    // Остаток попыток смены Amazon RN
    const remainingAmazon = useMemo(
        () => Math.max(0, 3 - (user?.user?.amazon_rn_changes || 0)),
        [user?.user?.amazon_rn_changes]
    );

    // Блокируем кнопку, если попытки закончились
    const isAmazonLocked = remainingAmazon <= 0;

    const internalClose = () => {
        onClose();
    };

    const handleSave = async () => {
        if (isAmazonLocked) {
            toast.error("No attempts left. Contact support to change.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const editDate = Date.now();

        try {
            setLoading(true);

            // Меняем только amz_name (остальные поля — null/undefined)
            const updatedUser = await updateUserDataFront(
                user?.user?.id,
                user?.user?.email, // email
                null, // newPassword
                user?.user?.username, // username
                reviewData?.review_name || user?.user?.amz_name, // amz_name -> новое значение из отзыва
                reviewData?.review_name || user?.user?.audible_name, // audible_name
            );

            // Обновляем стор с сервера (актуальный токен + payload)
            const data = await check();
            user.setUser(data);

            toast.success(
                `Profile updated successfully. New Reviewer Name: ${reviewData?.review_name}`
            , { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            onClose();
        } catch (error) {
            console.error("Error updating user data:", error);
            const errorMsg =
                error.response?.data?.message || "Failed to update profile. Please try again.";
            toast.error(errorMsg, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setLoading(false);
        }
    };

    const currentName = user?.user?.amz_name || "No Amazon Reviewer Name provided";
    const reviewName = reviewData?.review_name || "No Amazon Reviewer Name provided";
    const namesEqual = user?.user?.amz_name === reviewData?.review_name;

    return (
        <Modal show={show} onHide={onClose} reviewDate={reviewData} centered>
            <div className="modal-content">
                {/* Header */}
                <div className="modal-header small" style={{ height: 40 }}>
                    <h1 className="modal-title fs-6 text-muted m-0">
                        Automatic Approval System
                    </h1>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={onClose}
                    ></button>
                </div>

                {/* Body */}
                <div className="modal-body" style={{ lineHeight: "1.6" }}>

                    {namesEqual ? (
                        <div className="mb-3">
                            <p className="text-muted mb-2 d-inline">Success! New Reviewer Name:</p>
                            <h6 className="text-success fw-bold d-inline">
                                {" "}
                                "{reviewName}"
                            </h6>
                            <p className="text-muted mb-0 mt-2 small">
                                You can close this window and reinsert the review link into the link
                                checker to verify the assignment again with new parameters.
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className="mb-0">
                                <p className="text-muted mb-2 d-inline">
                                    Your Current Amazon Reviewer Name:{" "}
                                </p>
                                <h6 className="text-danger fw-bold d-inline">"{currentName}"</h6>

                                <p className="text-muted mb-2 mt-2 small">
                                    However, you are trying to confirm this assignment using a{" "}
                                    <span className="text-danger fw-bold d-inline">
                    different Amazon Reviewer Name
                  </span>{" "}
                                    than the one currently saved in your profile.
                                </p>

                                <p className="text-muted mb-1 d-inline">Reviewer Name from this review: </p>
                                <h6 className="text-danger fw-bold d-inline">"{reviewName}"</h6>

                                <p className="text-muted mb-0 mt-2 small">
                                    Would you like to update your Amazon Reviewer Name to{" "}
                                    <strong>{reviewName}</strong>?
                                </p>
                            </div>
                            {/* Остаток попыток */}
                            <div className="mb-2">
            <span className={`small ${isAmazonLocked ? "text-danger" : "text-muted"}`}>
              Remaining attempts for Amazon Reviewer Name:{" "}
                <strong>{remainingAmazon}</strong>
                {isAmazonLocked && " — Contact Support"}
            </span>
                            </div>
                        </>
                    )}

                    {/* CTA */}
                    <div className="mb-3 mt-0">
                        <div className="d-flex justify-content-center">
                            <Button
                                variant={isAmazonLocked ? "secondary" : "success"}
                                onClick={handleSave}
                                className="text-white btn btn-sm"
                                disabled={loading || isAmazonLocked}
                            >
                                {loading
                                    ? "Saving..."
                                    : isAmazonLocked
                                        ? "Contact support to change"
                                        : "Change Amazon Reviewer Name"}
                            </Button>
                        </div>

                        {!namesEqual && (
                            <>
                                <p className="text-muted mt-3 small text-start mb-2">
                                    This action will update your Amazon Reviewer Name to match the one
                                    found in this review. Changes are limited to{" "}
                                    <strong>three (3) attempts</strong> in total to prevent abuse.
                                    If you have no attempts left, please contact support.
                                </p>
                                <p className="text-danger small text-start mb-0">
                                    Note: This change does <strong>not</strong> affect your Amazon Reviewer
                                    Country Site. If both your reviewer name and country site have changed,
                                    close this window and update them manually in your{" "}
                                    <strong>Profile Settings</strong>.
                                </p>
                            </>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div
                    className="modal-footer small d-flex align-items-center justify-content-end gap-2 px-2"
                    style={{ height: 50, paddingTop: 0, paddingBottom: 0 }}
                >
                    <Button
                        variant="secondary"
                        onClick={internalClose}
                        className="text-white btn btn-sm"
                    >
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ChangeAmzName;
